





























import { Component, Prop, Vue } from "vue-property-decorator";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";

import draggable from "vuedraggable";

@Component({
  components: { draggable },
})
export default class LowRouteButtonCards extends Vue {
  @Prop({ type: Array, default: null }) routes!: Array<IPageConfig>;
  enabled = true;
  dragging = false;
}
